import { createSelector } from 'reselect';

const filterItems = (inputValue, allItems, numVisibleItems) => {
  if (inputValue.length !== 0) {
    const inputValueLower = inputValue.toLowerCase();
    const items = allItems.filter((item) => {
      return item.name.toLowerCase().indexOf(inputValueLower) === 0;
    });
    return items.length > numVisibleItems ? items.slice(0, numVisibleItems) : items;
  }
  return [];
};

const inputValue = ([s]) => {
  return s.inputValue;
};

const allItems = ([, p]) => {
  return p.model.allItems;
};

const numVisibleItems = ([, p]) => {
  return p.numVisibleItems;
};


export default createSelector(
  inputValue,
  allItems,
  numVisibleItems,
  filterItems
);



/** WEBPACK FOOTER **
 ** ./shared-components/SearchBar/filtered-selector.js
 **/